import { render, staticRenderFns } from "./ModernSidebarCurrency.vue?vue&type=template&id=0fdcba2c&scoped=true&"
import script from "./ModernSidebarCurrency.vue?vue&type=script&lang=js&"
export * from "./ModernSidebarCurrency.vue?vue&type=script&lang=js&"
import style0 from "./ModernSidebarCurrency.vue?vue&type=style&index=0&id=0fdcba2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdcba2c",
  null
  
)

export default component.exports